/**
 * Created by Georgi Dimov on 17.8.2017 г..
 */

import { EventDispatcher } from "../events/EventDispatcher";
import { Event } from "../events/Event";

export class Timer extends EventDispatcher{
    static TIMER_COMPLETE: string = "timerComplete";
    static TIMER: string = "timer";

    private _delay: number;
    private _repeatCount: number;
    private _currentCount: number = 0;
    private _delayedCall: gsap.TweenMax;

    constructor(delay: number, repeatCount: number = 0) {
        super();

        this._delay = delay;
        this._repeatCount = repeatCount;
    }

    get currentCount(): number {
        return this._currentCount;
    }

    get running(): boolean {
        return this._delayedCall != null;
    }

    get repeatCount(): number {
        return this._repeatCount;
    }

    set repeatCount(value: number) {
        this._repeatCount = Math.max(0, value);

        if(this.isFinished)
            this.stop();
    }

    get delay(): number {
        return this._delay;
    }

    set delay(value: number) {
        this._delay = Math.max(0, value);

        if(this.running) {
            this.stop();
            this.start();
        }
    }

    start(): void {
        if(this.running)
            return;

        this._delayedCall = gsap.TweenMax.delayedCall(this._delay, this.onDelay, null, this);
    }

    stop(): void {
        if(this.running) {
            this._delayedCall.kill();
            this._delayedCall = null;
        }
    }

    reset(): void {
        this.stop();

        this._currentCount = 0;
    }

    private get isFinished(): boolean {
        return this._currentCount >= this._repeatCount && this._repeatCount != 0;
    }

    private onDelay(): void {
        this._currentCount++;

        this.dispatchEvent(new Event(Timer.TIMER));

        if(this.isFinished) {
            this.stop();
            this.dispatchEvent(new Event(Timer.TIMER_COMPLETE));
        } else if(this.running) {
            this.stop();
            this.start();
        }
    }
}
